import React from 'react';
import ExpandableListModule from "../modules/ExpandableListModule";
import { TweenLite } from 'gsap';
import CountrySearch from "../components/CountrySearch";
import globals from '../globals';
import ResponsiveTable from "../elements/ResponsiveTable";
import Heading from "../elements/Heading";
import content from "../../../data/mobile-fleet/roaming.json";

class MobileRoaming extends React.Component {

	constructor(props) {
		super(props);

		this.state = {
			isLoaded: false,
			title: content.title,
			description: content.description,
			rates: content.rates,
			thingsToKnow: content.thingsToKnow,
			// USER INPUT
			search: '',
			countryList: [],
			currentCountry: {}
		};

		this.noResults = [{zone: 'no-results', country: 'No country found.', additional: ''}];
	}

	handleChange(event) {
		this.setState({search: event.target.value}, this.getCountries.bind(this));
	}

	handleSelect(event, data, inputEl) {
		event.preventDefault();

		if (data.zone === 'no-results') {
			inputEl.current.select();
		} else  {
			this.setState({
				countryList: [],
				search: data.country
			});

			this.animateTableOut();

			setTimeout(() => {
				this.setState({
					currentCountry: data
				}, this.animateTableIn.bind(this));
			}, 250);
		}
	}

	resetCountries() {
	    this.setState({
            search: '',
            countryList: '',
            currentCountry: {}
        });
    }

	animateTableOut() {
		TweenLite.to(this.tableWrapper, 0.25, {opacity: 0});
	}

	animateTableIn() {
        TweenLite.to(this.tableWrapper, 0.25, {opacity: 1});
	}

	getCountries() {
		if (this.state.search.length > 2) {
			clearTimeout(this.timer);

			this.timer = setTimeout(() => {
			    fetch(`/api/searchRoamingCountries/${this.state.search}`)
                    .then(response => response.json())
                    .then(response => {
                        if (response.length > 0) {
                            this.setState({countryList: response});
                        } else {
                            this.setState({countryList: this.noResults});
                        }
                    })
                    .catch(error => {
                        console.error(error);
                    })
			}, 500);
		}
	}

	getClassName() {
		if (this.state.currentCountry.zone) {
			let zone = this.state.currentCountry.zone;
			if (zone === 1) {
				return 'hide-zone2 hide-zone3 hide-zone4';
			} else if (zone === 2) {
				return 'hide-zone1 hide-zone3 hide-zone4';
			} else if (zone === 3) {
				return 'hide-zone1 hide-zone2 hide-zone4';
			} else {
			    return 'hide-zone2 hide-zone3 hide-zone4'
            }
		}

		return '';
	}

	render() {
	    const Note = <p className="m-0 mt-2 font-tiny">Note: for information purposes - subject to updates (additions, changes and/or deletions)</p>

		return (
		    <React.Fragment>
                <div className={`mobile-roaming ${this.getClassName()}`}>
                    <Heading title={this.state.title} className="text-center mb-5" />
                    <div className="row mb-5">
                        <div className="col-12 col-lg-8 col-lg-offset-2">
                            <div className="mb-5">
                                {this.state.description.map((item, key) => {
                                    return <p key={key} dangerouslySetInnerHTML={{__html: globals.noWidows(item)}} />;
                                })}
                            </div>
                            <CountrySearch
                                title="Find your zone:"
                                countryList={this.state.countryList}
                                search={this.state.search}
                                handleChange={this.handleChange.bind(this)}
                                handleSelect={this.handleSelect.bind(this)}
                                handleCancel={this.resetCountries.bind(this)}
                            />
                            {this.state.currentCountry.country ?
                                <div className="row mb-4">
                                    <div className="col-12 col-lg-4 col-lg-offset-4 text-center country-wrap">
                                        <h5 className="m-0 mb-1 bold">
                                            {this.state.currentCountry.country.trim()}
                                        </h5>
                                        <h5 className="m-0 mb-1 bold">Zone: {this.state.currentCountry.zone}</h5>
                                        <p className="m-0 font-small text-center">
                                            {this.state.currentCountry.type === 'N' ? 'Preferred network operator' : 'Non preferred network operator'}<br />
                                            MCC: {this.state.currentCountry.mcc}<span className="bold"> | </span>
                                            MNC: {this.state.currentCountry.mnc}
                                        </p>
                                    </div>
                                </div>
                            : ''}
                            <div ref={el => this.tableWrapper = el}>
                                <div className="mb-5 zone-1">
                                    <p className="m-0 mb-2 bold text-center">Zone 1 rates</p>
                                    <ResponsiveTable data={this.state.rates.zone1} />
                                    {Note}
                                </div>
                                <div className="mb-5 zone-2">
                                    <p className="m-0 mb-2 bold text-center">Zone 2 rates</p>
                                    <ResponsiveTable data={this.state.rates.zone2} />
                                    {Note}
                                </div>
                                <div className="mb-5 zone-3">
                                    <p className="m-0 mb-2 bold text-center">Zone 3 rates</p>
                                    <ResponsiveTable data={this.state.rates.zone3} />
                                    {Note}
                                </div>
                                <div className="zone-4">
                                    <p className="m-0 mb-2 bold text-center">Zone 4 rates</p>
                                    <ResponsiveTable data={this.state.rates.zone4} />
                                    {Note}
                                </div>
                            </div>

                        </div>
                    </div>
                    <div className="things-to-know-sub">
                        <ExpandableListModule data={this.state.thingsToKnow} title="Things you need to know about roaming" />
                    </div>
                </div>
            </React.Fragment>
		);
	}

}

export default MobileRoaming;


// WEBPACK FOOTER //
// ./resources/assets/js/mobileFleet/MobileRoaming.js